import { Tag as AntdTag } from "@mijadesign/web";
import type { TagProps as AntdTagProps } from "antd";

type RuntimeContext = {
  scope?: string;
  area?: string;
  data?: {
    rawValue?: unknown;
    displayValue?: unknown;
    status?: unknown;
    record?: Record<string, unknown>;
    [key: string]: unknown;
  };
};

interface TagWrapperProps extends AntdTagProps {
  children?: React.ReactNode;
  runtime?: {
    context?: RuntimeContext;
  };
  __runtimeContext?: RuntimeContext;
}

function TagWrapper({
  children,
  runtime,
  __runtimeContext,
  ...props
}: TagWrapperProps) {
  const runtimeContext = runtime?.context || __runtimeContext;
  const rawValue = runtimeContext?.data?.rawValue;
  const displayValue = runtimeContext?.data?.displayValue;
  const hasRawValue = rawValue !== undefined && rawValue !== null;
  const hasDisplayValue =
    displayValue !== undefined && displayValue !== null && displayValue !== "";
  const status = String(runtimeContext?.data?.status || "").toLowerCase();

  const statusColorMap: Record<string, AntdTagProps["color"]> = {
    success: "success",
    error: "error",
    processing: "processing",
    warning: "warning",
    default: "default",
  };
  const resolvedColor = props.color || statusColorMap[status];
  const resolvedChildren = hasDisplayValue
    ? String(displayValue)
    : hasRawValue
      ? String(rawValue)
      : children;

  return (
    <AntdTag {...props} color={resolvedColor}>
      {resolvedChildren}
    </AntdTag>
  );
}

export default TagWrapper;
